export function animating(node: HTMLElement) {
    const addAnimating = () => {
        node.classList.add("animating")
    }

    const removeAnimating = () => {
        node.classList.remove("animating")
    }

    node.addEventListener("introstart", addAnimating)
    node.addEventListener("introend", removeAnimating)
    node.addEventListener("outrostart", addAnimating)
    node.addEventListener("outroend", removeAnimating)

    return {
        destroy() {
            node.removeEventListener("introstart", addAnimating)
            node.removeEventListener("introend", removeAnimating)
            node.removeEventListener("outrostart", addAnimating)
            node.removeEventListener("outroend", removeAnimating)
        },
    }
}

/**
 * Transitioning allows a class to appended during CSS transitions
 * It also offers an animation frame callback to be called during each
 * frame during the transition. This is useful for recording information
 * used elsewhere. For example, the navigation width used to push over
 * the text
 * @param node
 * @param data
 * @returns
 */
export function transitioning(
    node: HTMLElement,
    data: {
        onAnimationFrame?: (e: HTMLElement) => void
        onTransitionSettled?: (e: HTMLElement) => void
        properties?: string[]
    } = {},
) {
    const properties = data.properties ? data.properties : ["transform"]
    const isProperty = (prop: string) => properties.includes(prop)
    const customJS = data?.onAnimationFrame
    const onTransitionSettled = data?.onTransitionSettled
    let stopped = true
    const activeProperties = new Set<string>()

    function animationFunction() {
        if (customJS) customJS(node)
        if (!stopped) window.requestAnimationFrame(animationFunction)
    }

    function addTransitionClass(e: TransitionEvent) {
        if (e.target !== node) return
        if (!isProperty(e.propertyName)) return
        activeProperties.add(e.propertyName)
        node.classList.add("transitioning")
        if (!stopped) return

        stopped = false
        if (customJS) animationFunction()
    }

    function removeTransitionClass(e: TransitionEvent) {
        if (e.target !== node) return
        if (!isProperty(e.propertyName)) return
        activeProperties.delete(e.propertyName)
        if (activeProperties.size > 0) {
            customJS?.(node)
            return
        }

        node.classList.remove("transitioning")
        stopped = true
        customJS?.(node)
        onTransitionSettled?.(node)
    }

    node.addEventListener("transitionstart", addTransitionClass)
    node.addEventListener("transitionend", removeTransitionClass)
    node.addEventListener("transitioncancel", removeTransitionClass)

    return {
        destroy() {
            node.removeEventListener("transitionstart", addTransitionClass)
            node.removeEventListener("transitionend", removeTransitionClass)
            node.removeEventListener("transitioncancel", removeTransitionClass)
        },
    }
}
